import type { ReactNode } from 'react';

import type { WidgetProps } from '@rjsf/utils';

import { formatNumber } from '@/components/forms/utils/formatNumber';
import { KeyValue } from '@/components/ui/keyValue/keyValue';

type Props = Pick<WidgetProps, 'label' | 'value' | 'name'>;

export const TextWidget = ({ label = '', value = '', name }: Props) => {
  if (label === 'Answer') {
    return (
      <div className="flex text-sm">
        {!value && Number(value) ? formatNumber(value, {}) : value}
      </div>
    );
  }

  const formatTextValue = (value: string): ReactNode => {
    if (
      typeof value === 'string' &&
      (value.startsWith('http://') || value.startsWith('https://'))
    ) {
      return (
        <a
          className="text-blue-500 dark:text-blue-600"
          href={value}
          rel="noopener noreferrer"
          target="_blank"
        >
          {value}
        </a>
      );
    }

    // ! This condition is really weird
    return !value && Number(value) ? formatNumber(value, {}) : value;
  };

  return (
    <KeyValue dataCyName={name} title={label}>
      {formatTextValue(value)}
    </KeyValue>
  );
};
